import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);
/*
<router-link to="/send" class="main-links">送信予定・履歴</router-link>
*/
export const routes = [
  {
    path: '/',
    name: 'Top',
    topbar: false,
    jpName: '',
    component: () => import('@/views/Top.vue'),
  },
  {
    path: '/client',
    name: 'Client',
    topbar: true,
    jpName: '🏢顧客登録・更新',
    component: () => import('@/views/Client.vue'),
  },
  {
    path: '/engineer',
    name: 'Engineer',
    topbar: true,
    jpName: '👩‍💼👨‍💼要員登録・更新',
    component: () => import('@/views/Engineer.vue'),
  },
  {
    path: '/annkenn',
    name: 'Annkenn',
    topbar: true,
    jpName: '📝案件登録・更新',
    component: () => import('@/views/Annkenn.vue'),
  },
  {
    path: '/mail',
    name: 'Mail',
    topbar: true,
    jpName: '📧メール配信',
    component: () => import('@/views/Mail.vue'),
  },
  {
    path: '/coordinator',
    name: 'Coordinator',
    topbar: true,
    jpName: '利用者情報修正・追加',
    component: () => import('@/views/Coordinator.vue'),
  },
  /*
  {
    path: '/mailbox',
    name: 'Mailbox',
    topbar: true,
    jpName: 'メール送信履歴・予定',
    component: () => import('@/views/Mailbox.vue'),
  },
  */
  {
    path: '/history',
    name: 'History',
    topbar: false,
    jpName: '操作履歴',
    component: () => import('@/views/History.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
